<template>
  <div class="con-wrap">
    <div v-if="active == 'init'" class="list-con full-page">
      <el-form
        size="medium"
        :inline="true"
        :model="queryForm"
        ref="queryForm"
        class="input-form-inline"
        @submit.native.prevent
      >
        <div>
          <el-form-item class="r-20" prop="plate">
            <el-input
              v-model="queryForm.plate"
              @keyup.enter.native="query"
              placeholder="车牌号"
            ></el-input>
          </el-form-item>
          <el-form-item class="r-20" prop="name">
            <el-input
              v-model="queryForm.name"
              @keyup.enter.native="query"
              placeholder="车辆绑定人"
            ></el-input>
          </el-form-item>
          <el-button
            v-if="hasPerm('outlay:manage:list')"
            type="primary"
            @click="query"
            >查询</el-button
          >
          <el-button v-if="hasPerm('outlay:manage:list')" @click="reset"
            >取消</el-button
          >
        </div>

        <div style="margin-bottom: 20px" class="expenseBtn">
          <el-button
            v-if="hasPerm('outlay:manage:fixedAssetsDep')"
            type="primary"
            @click="changeDepreciation"
            >固定资产折旧表</el-button
          >
          <el-button
            v-if="hasPerm('outlay:manage:record')"
            type="primary"
            @click="changeExpenseRecord"
            >车辆费用记录</el-button
          >
          <el-button
            v-if="hasPerm('outlay:manage:analysis')"
            type="primary"
            @click="changeExpenseAnalyst"
            >费用分析</el-button
          >
        </div>
      </el-form>
      <el-table
        ref="multipleTable"
        :data="tableData"
        tooltip-effect="dark"
        style="width: 100%"
        size="mini"
        stripe
        height="560px"
        @row-click="handleClickTableRow"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          type="selection"
          width="24"
          align="center"
          style="padding: 0"
        ></el-table-column>
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column
          prop="plateNum"
          width="80"
          label="车牌号"
        ></el-table-column>
        <el-table-column
          prop="name"
          width="80"
          label="车辆绑定人"
        ></el-table-column>
        <el-table-column
          prop="propertyOwner"
          width="80"
          label="产权方"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="companyName"
          label="运维公司"
          min-width="120"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="deptName"
          label="部门"
          min-width="120"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="buyTime"
          width="140"
          label="购车日期"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="ownPrice"
          width="140"
          label="维保支出（自费/元）"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="freePrice"
          width="140"
          label="维保支出（免费/元）"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="oilPrice"
          width="100"
          label="加油支出（元）"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="otherPrice"
          width="100"
          label="其他支出（元）"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column label="操作" width="350" fixed="right">
          <template slot-scope="scope">
            <el-button
              size="mini"
              type="text"
              v-if="hasPerm('outlay:archives')"
              @click.stop="editVehicleFile(scope.row.vin)"
              >车辆档案</el-button
            >
            <el-button
              size="mini"
              type="text"
              v-if="hasPerm('outlay:repair')"
              @click.stop="addMaintainCost(scope.row.vin)"
              >新增维保支出</el-button
            >
            <el-button
              size="mini"
              type="text"
              v-if="hasPerm('outlay:oil')"
              @click.stop="addFuelingCost(scope.row.vin)"
              >新增加油支出</el-button
            >
            <el-button
              size="mini"
              type="text"
              v-if="hasPerm('outlay:other')"
              @click.stop="addOtherCost(scope.row.vin)"
              >新增其他支出</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="limit"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
      <!-- 车辆档案 -->
      <el-dialog
        title="车辆档案"
        :visible.sync="vehicleFile"
        :close-on-click-modal="false"
        class="mini-dialog info-box"
      >
        <el-row>
          <el-col :span="12">
            <el-col :span="6">车辆型号：</el-col>
            <el-col :span="18">{{ vehicleFileData.vehicleModel }}</el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="6">车架号：</el-col>
            <el-col :span="18">{{ vehicleFileData.vin }}</el-col>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-col :span="6">生产日期：</el-col>
            <el-col :span="18">{{ vehicleFileData.productionTime }}</el-col>
          </el-col>
          <el-col :span="12">
            <el-col :span="6">车牌号：</el-col>
            <el-col :span="18">{{ vehicleFileData.plateNum }}</el-col>
          </el-col>
        </el-row>
        <el-row class="tableInput">
          <el-row class="tableInput_item inputItem">
            <el-col :span="4">产权方</el-col>
            <el-col :span="4">购入日期</el-col>
            <el-col :span="6">原值(不含税额/元)</el-col>
            <el-col :span="4">增值税(元)</el-col>
            <el-col :span="3">残值率(%)</el-col>
            <el-col :span="3">折旧年限</el-col>
          </el-row>
          <el-row class="tableInput_item">
            <el-col :span="4" class="placeInput">
              <input
                v-if="readonlyEdit"
                type="text"
                :class="[readonlyEdit ? 'border0' : 'border1']"
                :readonly="readonlyEdit"
                v-model="archivesEdit.propertyOwner"
              />
              <el-autocomplete
                v-else
                v-model.trim="archivesEdit.propertyOwner"
                :class="[readonlyEdit ? 'border0' : 'border1']"
                :fetch-suggestions="querySearchAsync"
                placeholder="请输入"
                @select="handleSelect"
                :popper-append-to-body="false"
                style="width:100%"
              >
                <!--  解决匹配不到提示无匹配数据 -->
                <template v-if="noData" slot-scope="{ item }">
                  <div class="default">{{ item.default }}</div>
                </template>
              </el-autocomplete>

              <!-- <el-select
                v-else
                v-model.trim="archivesEdit.propertyOwner"
                :class="[readonlyEdit ? 'border0' : 'border1']"
                filterable
                remote
                reserve-keyword
                placeholder="请选择"
                :remote-method="remoteMethod"
                :loading="loading"
                :no-data-text="'无此产权方'"
                @change="changeCheck"
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.value"
                  :value="item.value"
                  @click.native="selectOption(item)"
                >
                </el-option>
              </el-select> -->
            </el-col>
            <el-col :span="4" class="placeInput">
              <!-- <input
                type="date"
                placeholder="2020-05-08"
                :class="[readonlyEdit ? 'border0' : 'border1']"
                :readonly="readonlyEdit"
                v-model="archivesEdit.buyTime"
              /> -->
              <el-date-picker
                prefix-icon=" "
                v-model="archivesEdit.buyTime"
                :clearable="false"
                :readonly="readonlyEdit"
                :class="[readonlyEdit ? 'border0' : 'border1']"
                value-format="yyyy-MM-dd"
                type="date"
                style="width: calc(100% - 4px) !important;"
              >
              </el-date-picker>
            </el-col>
            <el-col :span="6">
              <input
                type="text"
                :class="[readonlyEdit ? 'border0' : 'border1']"
                :readonly="readonlyEdit"
                v-model="archivesEdit.originalPrice"
              />
            </el-col>
            <el-col :span="4">
              <input
                type="text"
                :class="[readonlyEdit ? 'border0' : 'border1']"
                :readonly="readonlyEdit"
                v-model="archivesEdit.taxAmount"
              />
            </el-col>
            <el-col :span="3">
              <input
                type="text"
                :class="[readonlyEdit ? 'border0' : 'border1']"
                :readonly="readonlyEdit"
                v-model="archivesEdit.depreciationRate"
              />
            </el-col>
            <el-col :span="3">
              <input
                type="text"
                :class="[readonlyEdit ? 'border0' : 'border1']"
                :readonly="readonlyEdit"
                v-model="archivesEdit.depreciationYears"
              />
            </el-col>
          </el-row>
        </el-row>
        <el-row style="text-align: center">
          <el-button type="primary" @click="editOrSave">{{
            vehicleFileBtn
          }}</el-button>
        </el-row>
      </el-dialog>
      <!-- 维保支出 -->
      <el-dialog
        title="新增维保支出"
        :visible.sync="maintainCost"
        :close-on-click-modal="false"
        class="mini-dialog info-box"
      >
        <el-form
          ref="maintainForm"
          :model="maintainForm"
          size="mini"
          :inline="true"
          :rules="rules"
        >
          <el-row class="tableInput maintainCost">
            <el-col :span="6" class="tableInput_item inputItem">
              <el-col>维修站名称</el-col>
              <el-col>受理时间</el-col>
              <el-col>完工时间</el-col>
              <el-col>受理里程(公里)</el-col>
              <el-col>自费金额(元)</el-col>
              <el-col>免费金额(元)</el-col>
              <el-col>维保结算单</el-col>
            </el-col>
            <el-col :span="18" class="tableInput_item inputEditItem">
              <el-col>
                <el-form-item prop="outlayName" inline-message>
                  <el-input type="text" v-model="maintainForm.outlayName" />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item prop="payTime">
                  <el-date-picker
                    prefix-icon=" "
                    v-model="maintainForm.payTime"
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="padding:0 15px"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item prop="completeTime">
                  <el-date-picker
                    prefix-icon=" "
                    value-format="yyyy-MM-dd"
                    v-model="maintainForm.completeTime"
                    type="date"
                    style="padding:0 15px"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item prop="acceptMileage" inline-message>
                  <el-input type="text" v-model="maintainForm.acceptMileage" />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item prop="payPrice">
                  <el-input type="text" v-model="maintainForm.payPrice" />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item prop="freePrice">
                  <el-input type="text" v-model="maintainForm.freePrice" />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item prop="file">
                  <el-upload
                    ref="upload"
                    class="upload-demo"
                    accept=".jpg,.png,.jpeg"
                    :action="`/api/outlay/manage/repair`"
                    :http-request="uploadSectionFile"
                    :on-change="addfile"
                    :data="myData()"
                    :auto-upload="false"
                    :limit="1"
                    :file-list="fileList"
                  >
                    <el-button size="small" type="text">上传</el-button>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-col>
          </el-row>
          <el-row style="text-align: center">
            <el-button type="primary" @click="maintainSave">保存</el-button>
          </el-row>
        </el-form>
      </el-dialog>
      <!-- 加油支出 -->
      <el-dialog
        title="新增加油支出"
        :visible.sync="fuelingCost"
        :close-on-click-modal="false"
        class="mini-dialog info-box"
      >
        <el-form
          ref="OilForm"
          :model="OilForm"
          size="mini"
          :inline="true"
          :rules="rules"
        >
          <el-row class="tableInput maintainCost">
            <el-col :span="6" class="tableInput_item inputItem">
              <el-col>加油站名称</el-col>
              <el-col>交易时间</el-col>
              <el-col>油品</el-col>
              <el-col>单价(元/升)</el-col>
              <el-col>数量(升)</el-col>
              <el-col>金额(元)</el-col>
              <el-col>付款方式</el-col>
              <el-col>加油票据</el-col>
            </el-col>
            <el-col :span="18" class="tableInput_item inputEditItem">
              <el-col>
                <el-form-item prop="outlayName">
                  <el-input type="text" v-model="OilForm.outlayName" />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item prop="payTime">
                  <el-date-picker
                    size="mini"
                    prefix-icon=" "
                    value-format="yyyy-MM-dd"
                    v-model="OilForm.payTime"
                    type="date"
                    style="padding:0 15px"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item>
                  <el-input type="text" v-model="OilForm.goodsName" />
                </el-form-item>
              </el-col>
              <el-col
                ><el-form-item>
                  <el-input type="text" v-model="OilForm.unitPrice" />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item>
                  <el-input type="text" v-model="OilForm.amount" />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item>
                  <el-input type="text" v-model="OilForm.payPrice" />
                </el-form-item>
              </el-col>
              <el-col
                ><el-form-item>
                  <el-input type="text" v-model="OilForm.payType" />
                </el-form-item>
              </el-col>
              <el-col>
                <el-form-item prop="file">
                  <el-upload
                    ref="uploadOil"
                    class="upload-demo"
                    accept=".jpg,.png,.jpeg"
                    :auto-upload="false"
                    :on-change="addfile"
                    :limit="1"
                    :action="`/api/outlay/manage/oil`"
                    :http-request="uploadSectionFileOil"
                    :data="myOilData()"
                    :file-list="fileListOil"
                  >
                    <el-button size="small" type="text">上传</el-button>
                  </el-upload>
                </el-form-item>
              </el-col>
            </el-col>
          </el-row>
          <el-row style="text-align: center">
            <el-button type="primary" @click="oilSave">保存</el-button>
          </el-row>
        </el-form>
      </el-dialog>
      <!-- 其他支出 -->
      <el-dialog
        title="新增其他支出"
        :visible.sync="otherCost"
        :close-on-click-modal="false"
        class="mini-dialog info-box"
      >
        <el-form
          ref="OtherForm"
          :model="OtherForm"
          size="mini"
          :inline="true"
          :rules="rules"
        >
          <el-row>
            <el-col :span="20">
              <el-row class="tableInput maintainCost">
                <el-col :span="6" class="tableInput_item inputItem">
                  <el-col>支出名称</el-col>
                  <el-col>支出时间</el-col>
                  <el-col>金额(元)</el-col>
                  <el-col>票据</el-col>
                </el-col>
                <el-col :span="18" class="tableInput_item inputEditItem">
                  <el-col>
                    <el-form-item prop="outlayType" class="border">
                      <el-input
                        v-if="addOtherCostInput"
                        type="text"
                        v-model="OtherForm.outlayType"
                      />
                      <select
                        v-else
                        style="
                          height: 34px;
                          width: 100%;
                          outline: none;
                          border: none;
                        "
                        v-model="OtherForm.outlayType"
                        placeholder="请选择"
                      >
                        <option
                          v-for="item in typeList"
                          :key="item.code"
                          :label="item.value"
                          :value="item.code"
                        ></option>
                      </select>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item prop="payTime">
                      <el-date-picker
                        size="mini"
                        prefix-icon=" "
                        value-format="yyyy-MM-dd"
                        v-model="OtherForm.payTime"
                        type="date"
                        class="picker"
                        style="padding:0 15px"
                      >
                      </el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item prop="payPrice">
                      <el-input type="text" v-model="OtherForm.payPrice" />
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item prop="payPrice">
                      <el-upload
                        ref="uploadOther"
                        class="upload-demo"
                        accept=".jpg,.png,.jpeg"
                        :auto-upload="false"
                        :limit="1"
                        :action="`/api/outlay/manage/other`"
                        :http-request="uploadSectionFileOther"
                        :data="myOtherData()"
                        :on-change="addfile"
                        :file-list="fileListOther"
                      >
                        <el-button size="small" type="text">上传</el-button>
                      </el-upload>
                    </el-form-item>
                  </el-col>
                </el-col>
              </el-row>
            </el-col>
            <el-col
              :span="4"
              style="
                padding-top: 30px !important;
                padding-left: 10px !important;
              "
            >
              <el-button type="text" @click="addOtherCostItem"
                >新增支出项</el-button
              >
            </el-col>
          </el-row>
          <el-row style="text-align: center">
            <el-button type="primary" @click="otherSave">保存</el-button>
          </el-row>
        </el-form>
      </el-dialog>
    </div>
    <depreciation
      key="depreciation"
      v-if="active == 'depreciation'"
      @goback="goback"
    ></depreciation>
    <expense-record
      key="expenseRecord"
      v-if="active == 'expenseRecord'"
      @goback="goback"
      :vinList="vinList"
    ></expense-record>
    <expense-analyst
      key="expenseAnalyst"
      v-if="active == 'expenseAnalyst'"
      @goback="goback"
    ></expense-analyst>
  </div>
</template>

<script>
import Depreciation from "./components/Depreciation.vue";
import ExpenseRecord from "./components/ExpenseRecord.vue";
import ExpenseAnalyst from "./components/ExpenseAnalyst";
export default {
  components: {
    Depreciation,
    ExpenseRecord,
    ExpenseAnalyst,
  },
  data() {
    return {
      rules: {
        isEmpty: "请将信息填写完整",
        // outlayName: [
        //   { required: true, message: "请输入名称", trigger: "blur" },
        // ],
        // payTime: [
        //   {
        //     type: "date",
        //     required: true,
        //     message: "请选择日期",
        //     trigger: "change",
        //   },
        // ],
        // completeTime: [
        //   {
        //     type: "date",
        //     required: true,
        //     message: "请选择日期",
        //     trigger: "change",
        //   },
        // ],
        // acceptMileage: [
        //   {
        //     pattern: this.$formRules.non_negative,
        //     required: true,
        //     trigger: "blur",
        //     message: this.$formRules.non_negativeMsg,
        //   },
        // ],
        // payPrice: [
        //   { required: true, message: "请输入正确的数字", trigger: "blur" },
        // ],
        // freePrice: [
        //   { required: true, message: "请输入正确的数字", trigger: "blur" },
        // ],
      },
      active: "init",
      vinList: [],
      vehicleFile: false,
      vehicleFileBtn: "编辑",
      readonlyEdit: true,
      maintainCost: false,
      maintainForm: {
        payPrice: "",
      },
      fuelingCost: false,
      OilForm: {},
      otherCost: false,
      otherCostItem: "",
      OtherForm: {},
      addOtherCostInput: false,
      queryForm: {
        name: "",
        plate: "",
      },
      currentPage: 1,
      limit: 10,
      total: 0,
      tableData: [],
      vehicleFileData: {},
      archivesEdit: {},
      fileList: [],
      fileListOil: [],
      fileListOther: [],
      tableVal: [],
      typeList: [],
      ownershipName: [], // 产权方名称列表
      options: [],
      loading: false,
      change: false,
      queryKey: "",
      restaurants: [],
      noData: false, // 是否匹配到数据了
    };
  },
  mounted() {
    this.getOutlayList();
    this.getOwnerNameList().then(() => {
      this.restaurants = this.ownershipName;
    });
  },
  methods: {
    querySearchAsync(queryString, cb) {
      let restaurants = this.restaurants;
      let results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;
      this.noData = false;
      if (results.length === 0) {
        results = [{ default: "无此产权方" }];
        this.noData = true;
      }
      // 调用 callback 返回建议列表的数据
      results.map((item) => {
        return item.value;
      });
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 1000 * Math.random());
    },
    createStateFilter(queryString) {
      return (restaurant) => {
        let restaurants =
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) !==
          -1;
        return restaurants;
      };
    },
    // 选中搜索的数据
    handleSelect(item) {
      console.log(item);
      // 选中数据之后立即执行搜索结果
      // this.searchVehicle()
    },
    // // 选择框内容改变触发
    // remoteMethod(query) {
    //   this.change = true;
    //   console.log(query);
    //   this.queryKey = query;
    //   if (query !== "") {
    //     this.loading = true;
    //     setTimeout(() => {
    //       this.loading = false;
    //       this.getOwnerNameList();
    //       // 筛选出产权方列表中是否包含输入的文字，模糊匹配
    //       this.options = this.ownershipName.filter((item) => {
    //         return item.value.toLowerCase().indexOf(query.toLowerCase()) > -1;
    //       });
    //     }, 200);
    //   } else {
    //     this.options = [];
    //   }
    // },
    // 获取产权方名称列表
    async getOwnerNameList() {
      let { data: res } = await this.$axios.get(
        "/api/property/management/getName"
      );
      if (res.code == 1) {
        this.ownershipName = res.data.map((item, index) => {
          return { id: index, value: item };
        });
      } else {
        this.$message.warning(res.msg);
      }
    },
    // 获取费用管理分页
    async getOutlayList() {
      let obj = {
        limit: this.limit,
        page: this.currentPage,
        plate: this.queryForm.plate,
        name: this.queryForm.name,
      };
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/outlay/manage/list", {
        params: obj,
      });
      if (res.code == 1) {
        _this.tableData = res.data.list;
        _this.total = res.data.totalCount;
      }
    },
    query() {
      this.getOutlayList();
    },
    reset() {
      this.$resetForm(this, "queryForm");
      this.getOutlayList();
    },
    // 车辆档案弹窗打开
    async editVehicleFile(vin) {
      let _this = this;
      _this.change = false;
      let { data: res } = await _this.$axios.get(
        `/api/outlay/manage/archives/${vin}`
      );
      if (res.code == 1) {
        _this.vehicleFileData = res.data;
        _this.archivesEdit = res.data.archivesEdit;
        if (!res.data.archivesEdit) {
          _this.archivesEdit = {
            archivesEdit: "",
            buyTime: "",
            depreciationRate: "",
            depreciationYears: "",
            originalPrice: "",
            taxAmount: "",
          };
        }
      }
      _this.vehicleFile = true;
      _this.readonlyEdit = true;
      _this.vehicleFileBtn = "编辑";
    },
    // 编辑或者保存车辆档案
    editOrSave() {
      let _this = this;
      if (_this.readonlyEdit) {
        _this.readonlyEdit = false;
        _this.vehicleFileBtn = "保存";
      } else {
        _this.confirmEditOrSave();
      }
    },
    async confirmEditOrSave() {
      let _this = this;
      let op = _this.ownershipName.find((item) => {
        return item.value == _this.archivesEdit.propertyOwner;
      });
      if (op != undefined) {
        let obj = {
          buyTime: _this.archivesEdit.buyTime,
          propertyOwner: _this.archivesEdit.propertyOwner,
          depreciationRate: _this.archivesEdit.depreciationRate,
          depreciationYears: _this.archivesEdit.depreciationYears,
          originalPrice: _this.archivesEdit.originalPrice,
          taxAmount: _this.archivesEdit.taxAmount,
          vin: _this.vehicleFileData.vin,
        };
        let { data: res } = await _this.$axios.post(
          "/api/outlay/manage/archives",
          obj
        );
        if (res.code == 1) {
          _this.$message.success("操作成功");
          _this.vehicleFile = false;
          _this.queryKey = "";
          _this.getOutlayList();
        }
      } else {
        // _this.vehicleFile = false;
        this.$message.warning(
          "产权方不存在，请先前往产权方管理页面添加对应的产权方名称！"
        );
      }

      // let flag;
      // // !_this.change 未改变输入框数据
      // // 优先判断是否改变了输入框数据，如果没改变直接发送请求，如果改变了就判断是否options有相匹配的数据
      // if (!_this.change || _this.options.length != 0) {
      //   // Find匹配不到时返回undefined
      //   flag =
      //     _this.options.find((item) => {
      //       return item.value == _this.queryKey;
      //     }) || !_this.change
      //       ? "false"
      //       : flag;
      //   // flag = !_this.change ? "false" : flag;
      //   if (flag) {
      //     // 验证通过
      //     let obj = {
      //       buyTime: _this.archivesEdit.buyTime,
      //       propertyOwner: _this.archivesEdit.propertyOwner,
      //       depreciationRate: _this.archivesEdit.depreciationRate,
      //       depreciationYears: _this.archivesEdit.depreciationYears,
      //       originalPrice: _this.archivesEdit.originalPrice,
      //       taxAmount: _this.archivesEdit.taxAmount,
      //       vin: _this.vehicleFileData.vin,
      //     };
      //     let { data: res } = await _this.$axios.post(
      //       "/api/outlay/manage/archives",
      //       obj
      //     );
      //     if (res.code == 1) {
      //       _this.$message.success("操作成功");
      //       _this.vehicleFile = false;
      //       _this.getOutlayList();
      //     }
      //   }
      // }
      // // 改变输入框的值且没有匹配数据
      // if ((_this.change && _this.options.length == 0) || !flag) {
      //   // _this.vehicleFile = false;
      //   this.$message.warning(
      //     "产权方不存在，请先前往产权方管理页面添加对应的产权方名称！"
      //   );
      // }
    },
    addfile(file, fileList) {
      this.fileList = fileList;
      this.fileListOil = fileList;
      this.fileListOther = fileList;
    },
    // 新增维保支出
    addMaintainCost(vin) {
      let _this = this;
      _this.maintainCost = true;
      _this.fileList = [];
      _this.maintainForm = {};
      _this.maintainForm.vin = vin;
      _this.$resetForm(_this, "maintainForm");
    },
    myData() {
      return {
        vin: this.maintainForm.vin,
        outlayName: this.maintainForm.outlayName,
        payPrice: this.maintainForm.payPrice,
        freePrice: this.maintainForm.freePrice,
        payType: 0,
        payTime: this.maintainForm.payTime,
        completeTime: this.maintainForm.completeTime,
        acceptMileage: this.maintainForm.acceptMileage,
      };
    },
    async uploadSectionFile(parm) {
      let _this = this;
      let fileObj = parm.file;
      // FormData 对象
      let form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      form.append("vin", this.maintainForm.vin);
      form.append("outlayName", this.maintainForm.outlayName);
      form.append("payPrice", this.maintainForm.payPrice);
      form.append("freePrice", this.maintainForm.freePrice);
      form.append("payType", 0);
      form.append("payTime", this.maintainForm.payTime);
      form.append("completeTime", this.maintainForm.completeTime);
      form.append("acceptMileage", this.maintainForm.acceptMileage);
      let { data: res } = await _this.$axios.post(
        "/api/outlay/manage/repair",
        form
      );
      if (res.code == 1) {
        _this.maintainCost = false;
        _this.getOutlayList();
        _this.$message.success("上传成功");
        _this.$refs.maintainForm.clearFiles();
        _this.fileList = [];
      } else {
        // _this.$refs.maintainForm.clearFiles()
        // _this.fileList = []
        _this.$message.warning(res.msg);
      }
    },
    // 保存表单数据校验
    maintainSave() {
      let _this = this;
      console.log(_this.fileList);
      if (
        !_this.maintainForm.outlayName | !_this.maintainForm.payTime ||
        !_this.maintainForm.completeTime ||
        !_this.maintainForm.acceptMileage ||
        !_this.maintainForm.payPrice ||
        !_this.maintainForm.freePrice ||
        _this.fileList.length == 0
      ) {
        _this.$message.warning(_this.$refs.maintainForm.rules.isEmpty);
        return false;
      } else if (
        !_this.$formRules.non_negative.test(_this.maintainForm.acceptMileage)
      ) {
        _this.$message.warning(_this.$formRules.non_negativeMsg);
        return false;
      } else if (
        !_this.$formRules.non_negative.test(_this.maintainForm.payPrice)
      ) {
        _this.$message.warning(_this.$formRules.non_negativeMsg);
        return false;
      } else if (
        !_this.$formRules.non_negative.test(_this.maintainForm.freePrice)
      ) {
        _this.$message.warning(_this.$formRules.non_negativeMsg);
        return false;
      }
      _this.$refs.maintainForm.validate((valid) => {
        if (valid) {
          _this.$refs.upload.submit();
          return false;
        }
      });
    },
    // 新增加油支出
    addFuelingCost(vin) {
      let _this = this;
      _this.fuelingCost = true;
      _this.fileListOil = [];
      _this.OilForm = {};
      _this.OilForm.vin = vin;
    },
    myOilData() {
      return {
        vin: this.OilForm.vin,
        outlayName: this.OilForm.outlayName,
        payPrice: this.OilForm.payPrice,
        unitPrice: this.OilForm.unitPrice,
        payType: this.OilForm.payType,
        payTime: this.OilForm.payTime,
        goodsName: this.OilForm.goodsName,
        amount: this.OilForm.amount,
      };
    },
    async uploadSectionFileOil(parm) {
      let _this = this;
      let fileObj = parm.file;
      // FormData 对象
      let form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      form.append("vin", this.OilForm.vin);
      form.append("outlayName", this.OilForm.outlayName);
      form.append("payPrice", this.OilForm.payPrice);
      form.append("unitPrice", this.OilForm.unitPrice);
      form.append("payType", this.OilForm.payType);
      form.append("payTime", this.OilForm.payTime);
      form.append("goodsName", this.OilForm.goodsName);
      form.append("amount", this.OilForm.amount);
      let { data: res } = await _this.$axios.post(
        "/api/outlay/manage/oil",
        form
      );
      if (res.code == 1) {
        _this.fuelingCost = false;
        _this.getOutlayList();
        _this.$message.success("上传成功");
        _this.fileListOil = [];
      } else {
        // _this.fileListOil = []
        _this.$message.warning(res.msg);
      }
    },
    oilSave() {
      let _this = this;
      console.log(this.fileListOil);
      if (
        !_this.OilForm.outlayName | !_this.OilForm.payTime ||
        !_this.OilForm.goodsName ||
        !_this.OilForm.unitPrice ||
        !_this.OilForm.amount ||
        !_this.OilForm.payPrice ||
        !_this.OilForm.payType ||
        _this.fileListOil.length == 0
      ) {
        _this.$message.warning(_this.$refs.OilForm.rules.isEmpty);
        return false;
      } else if (!_this.$formRules.non_negative.test(_this.OilForm.unitPrice)) {
        _this.$message.warning(_this.$formRules.non_negativeMsg);
        return false;
      } else if (!_this.$formRules.non_negative.test(_this.OilForm.amount)) {
        _this.$message.warning(_this.$formRules.non_negativeMsg);
        return false;
      } else if (!_this.$formRules.non_negative.test(_this.OilForm.payPrice)) {
        _this.$message.warning(_this.$formRules.non_negativeMsg);
        return false;
      }
      _this.$refs.OilForm.validate((valid) => {
        if (valid) {
          _this.$refs.uploadOil.submit();
          return false;
        }
      });
    },
    // 新增其他支出
    addOtherCost(vin) {
      let _this = this;
      _this.otherCost = true;
      _this.addOtherCostInput = false;
      _this.fileListOther = [];
      _this.OtherForm = {};
      _this.OtherForm.vin = vin;
      _this.getOutlayOtherPayName();
    },
    // 新增其他支出项
    addOtherCostItem() {
      let _this = this;
      _this.addOtherCostInput = true;
    },
    myOtherData() {
      return {
        vin: this.OtherForm.vin,
        outlayType: this.OtherForm.outlayType,
        payPrice: this.OtherForm.payPrice,
        payType: 0,
        payTime: this.OtherForm.payTime,
      };
    },
    // 获取其他支出项
    async getOutlayOtherPayName() {
      let _this = this;
      let { data: res } = await _this.$axios.get(
        "/api/sys/dict/outlayOtherPayName"
      );
      if (res.code == 1) {
        _this.typeList = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    async uploadSectionFileOther(parm) {
      let _this = this;
      let fileObj = parm.file;
      // FormData 对象
      let form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      form.append("vin", this.OtherForm.vin);
      form.append("outlayType", this.OtherForm.outlayType);
      form.append("payPrice", this.OtherForm.payPrice);
      form.append("payType", 0);
      form.append("payTime", this.OtherForm.payTime);
      console.log(form);
      let { data: res } = await _this.$axios.post(
        "/api/outlay/manage/other",
        form
      );
      if (res.code == 1) {
        _this.otherCost = false;
        _this.getOutlayList();
        _this.$message.success("上传成功");
        _this.fileListOther = [];
      } else {
        // _this.fileListOther = []
        _this.$message.warning(res.msg);
      }
    },
    otherSave() {
      let _this = this;
      console.log(_this.fileListOther);
      if (
        !_this.OtherForm.outlayType | !_this.OtherForm.payTime ||
        !_this.OtherForm.payPrice ||
        _this.fileList.length == 0
      ) {
        _this.$message.warning(_this.$refs.OtherForm.rules.isEmpty);
        return false;
      } else if (
        !_this.$formRules.non_negative.test(_this.OtherForm.payPrice)
      ) {
        _this.$message.warning(_this.$formRules.non_negativeMsg);
        return false;
      }
      _this.$refs.OtherForm.validate((valid) => {
        if (valid) {
          _this.$refs.uploadOther.submit();
          return false;
        }
      });
    },
    // 切换固定资产折旧
    changeDepreciation() {
      let _this = this;
      _this.active = "depreciation";
    },
    // 切换费用记录
    changeExpenseRecord() {
      let _this = this;
      if (_this.tableVal.length == 0) {
        _this.$message.error("请先选择车辆");
      } else {
        _this.active = "expenseRecord";
      }
    },
    changeExpenseAnalyst() {
      let _this = this;
      _this.active = "expenseAnalyst";
    },
    goback() {
      let _this = this;
      _this.active = "init";
      _this.tableVal = [];
    },
    //pagesize改变时触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    //页数改变时触发
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getOutlayList();
    },
    // -------------------
    //选择数据变化监控
    handleSelectionChange(val) {
      this.tableVal = val;
      let vinList = [];
      this.tableVal.map((item) => {
        vinList.push(item.vin);
      });
      this.vinList = vinList.toString();
    },
    handleClickTableRow(row) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
  },
};
</script>

<style lang="scss" scoped>
.placeInput {
  height: 34px !important;
  /deep/ .el-date-editor {
    height: 30px !important;
    line-height: 30px !important;
  }
  /deep/ .el-input__inner {
    height: 30px !important;
    line-height: 30px !important;
    padding-right: 0px;
  }
  input {
    &::-moz-placeholder {
      color: #bbb;
    }
    &::-ms-input-placeholder {
      color: #bbb;
    }
    &::-webkit-input-placeholder {
      color: #bbb;
    }
  }
}
.con-wrap > div {
  height: 100%;
  overflow: auto;
}
.top {
  height: 48px;
  line-height: 48px;
  display: block;
  margin-bottom: 20px;
  padding-left: 20px;
  background-color: #fff;
}
.full-page {
  padding: 0 20px;
  background: #fff;
}
.dialog-title {
  width: 100%;
  height: 20px;
  padding-left: 10px;
  margin-bottom: 10px;
  border-left: 3px solid #0093ff;
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
.expenseBtn /deep/ .el-button {
  padding: 0px 15px;
  width: auto;
}
//详情弹窗样式
.info-box /deep/ .el-dialog {
  width: 750px;
  padding-bottom: 20px;
  .el-form-item {
    margin: 0px !important;
    .el-form-item__content {
      line-height: 34px;
    }
  }
}
.info-box /deep/ .el-dialog {
  .tableInput {
    border-top: 1px solid #333;
    border-left: 1px solid #333;
    margin: 30px 0px !important;
    .tableInput_item {
      border-bottom: 1px solid #333;
      .el-col {
        text-align: center;
        border-right: 1px solid #333;
        input {
          width: 100%;
          border: none;
          outline: none;
          text-align: center;
        }
      }
    }
    .inputItem {
      background: #f4f4f4;
    }
  }
  .maintainCost {
    .tableInput_item {
      border-bottom: none;
      .el-col {
        border-bottom: 1px solid #333;
      }
    }
    .inputEditItem {
      .el-col {
        text-align: left !important;
      }
      input {
        text-align: left !important;
      }
      .border {
        .el-form-item__content {
          line-height: 0;
        }
      }
    }
  }
}
.info-box /deep/ .el-dialog__body {
  color: #333;
  .el-input--prefix .el-input__inner {
    padding-left: 0px;
  }
}
.dialog-title {
  width: 100%;
  height: 20px;
  padding-left: 10px;
  margin-bottom: 10px;
  border-left: 3px solid #0093ff;
  font-size: 14px;
  font-weight: bold;
  color: #333;
}
.dialog-label {
  font-weight: bold;
}
.info-box /deep/ .el-row {
  line-height: 34px;
}
/deep/ .upload-demo {
  position: relative;
}
/deep/ .el-upload-list {
  position: absolute;
  top: 5px;
  background: #fff;
  .el-upload-list__item:first-child {
    margin-top: 0px !important;
  }
  // .el-upload-list__item-name{
  //   color:#0094FF;
  // }
}
//车辆档案编辑状态样式突出
.border1 {
  width: calc(100% - 4px) !important;
  height: 30px;
  border: 1px solid #aaa !important;
  border-radius: 4px;
  margin-top: 1px;
}

::v-deep .el-autocomplete-suggestion {
  width: auto !important;
}
::v-deep .el-autocomplete-suggestion li {
  cursor: pointer;
  overflow: visible !important;
}

::v-deep .el-dialog .tableInput .tableInput_item .el-col input {
  padding: 0;
  height: 26px !important;
  line-height: 26px !important;
}
::v-deep .el-autocomplete > .el-input {
  top: -2px;
}
::v-deep .el-autocomplete > .el-input > .el-input__suffix {
  top: -2px;
}
</style>
